import {Injectable} from "@angular/core";
import {ListRemote} from "@app/core/lists/domain/list.remote";
import {Observable} from "rxjs";
import {List} from "@app/core/lists/domain/list";

@Injectable({
    providedIn: 'root'
})
export class RenameListUseCase {

    constructor(private listRemote:ListRemote) {
    }

    execute(listId:number, newName:string): Observable<List> {
        return this.listRemote.renameList(listId,newName);
    }

}